// src/features/boe/components/programs/Program1000.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1000_CONFIG = {
  fullName: "COMMUNITY SERVICES",
  docId: "1000",

  fieldDefs: [
    // Positions (counts)
    {
      key: "positionsCustodians",
      label: "Positions – Custodians",
      valueType: "count",
      sources: [{ block: "Positions", key: "Custodians" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },

    // Salaries
    {
      key: "salariesCustodians",
      label: "Salaries – Custodians",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Custodians" },
        { block: "Salaries", key: "Custodial, High School" }, // older label
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesPartTimeSystemwide",
      label: "Part Time / Over Time – Systemwide",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Part Time / Over Time SystemWide" },
        { block: "Salaries", key: "Part-Time/Over-Time, Systemwide" },
        { block: "Salaries", key: "Part Time / Over Time Systemwide" }, // 2026 Proposed casing
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // Salaries – Audio Visual (moved from Materials to Salaries in data)
    {
      key: "salariesAudioVisual",
      label: "Audio-Visual Services",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Audio-Visual Services" }],
      group: "salaries",
      defaultVisible: false,
    },

    // Supplies / Materials
    {
      key: "materialsSupplies",
      label: "Supplies / Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Supplies / Materials" },
        { block: "Supplies / Materials", key: "Supplies" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // Offsets (renamed from Other -> Offsets, and "Custodial Fee Offset" -> "Custodial Fee")
    {
      key: "custodialFee",
      label: "Custodial Fee",
      valueType: "currency",
      sources: [
        { block: "Offsets", key: "Custodial Fee" }, // new structure
        { block: "Other", key: "Custodial Fee Offset" }, // backward compat (older docs)
      ],
      group: "offsets",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approvedMain",
      title: "1000 COMMUNITY SERVICES – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsCustodians",
        "positionsSecretarial",
        "salariesCustodians",
        "salariesSecretarial",
        "salariesPartTimeSystemwide",
        "salariesAudioVisual",
        "materialsSupplies",
        "custodialFee",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsCustodians: { minWidth: "130px" },
        positionsSecretarial: { minWidth: "130px" },

        // Salaries
        salariesCustodians: { minWidth: "150px" },
        salariesSecretarial: { minWidth: "140px" },
        salariesPartTimeSystemwide: { minWidth: "210px" },
        salariesAudioVisual: { minWidth: "190px" },

        // Materials / Offsets
        materialsSupplies: { minWidth: "160px" },
        custodialFee: { minWidth: "150px" },
      },
    },
    {
      id: "actualMain",
      title: "1000 COMMUNITY SERVICES – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsCustodians",
        "positionsSecretarial",
        "salariesCustodians",
        "salariesSecretarial",
        "salariesPartTimeSystemwide",
        "salariesAudioVisual",
        "materialsSupplies",
        "custodialFee",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsCustodians: { minWidth: "130px" },
        positionsSecretarial: { minWidth: "130px" },

        // Salaries
        salariesCustodians: { minWidth: "150px" },
        salariesSecretarial: { minWidth: "140px" },
        salariesPartTimeSystemwide: { minWidth: "210px" },
        salariesAudioVisual: { minWidth: "190px" },

        // Materials / Offsets
        materialsSupplies: { minWidth: "160px" },
        custodialFee: { minWidth: "150px" },
      },
    },
  ],

  // null = "sum all currency fields" for the inflation chart
  inflationSumFields: null,
};

export function Program1000(props) {
  return (
    <ProgramBudget programId="1000" config={PROGRAM_1000_CONFIG} {...props} />
  );
}
